<script>
import { onMounted, ref } from 'vue';
import { useLanguagesStore } from '@/stores/languages';
import { useCustomerStore } from '@/stores/customer';

export default {
	setup() {
		const languagesStore = useLanguagesStore();
		const customerStore = useCustomerStore();
		const language_name = ref(null);
		const language = ref({ language_id: null });
		const betslip_changes = ref('');

		const changeLanguage = (id) => {
			language.value.language_id = id;
			languagesStore.changeLanguage(language.value);
		}

		onMounted(() => {
			language.value.language_id = languagesStore.selectedLanguage.id;
			language_name.value = languagesStore.selectedLanguage.name;
			if (customerStore.isLoggedIn) {
				betslip_changes.value = customerStore.getCustomer.betslip_changes;
			} else {
				betslip_changes.value = 'always_ask';
			}
		});

		return {
			languagesStore,
			language_name,
			language,
			changeLanguage
		};
	}
};
</script>


<template>
	<div class="content-main">
		<div class="title-main">
				<svg class="normal-img"
					xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
					style="shape-rendering:geometricPrecision; stroke: var(--white); width: 30px; height: 30px; margin-top: 6px; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
					viewBox="0 0 34 34" xmlns:xlink="http://www.w3.org/1999/xlink">
					<use :xlink:href="'/assets/icons/lang-ico.svg#svg3108'"/>
				</svg>
			<h3>{{ $t('account.account_preferences.language') }}</h3>
		</div>
		<form>
			<div class="lang-options">
				<div  class="radio-btn" v-for="(language,index) in languagesStore.getLanguages" :key="index">
					<input type="radio" name="lang"  :value="language.id" :checked="language.id == languagesStore.selectedLanguage.id" @change="changeLanguage(language.id)">
					<label>{{ $t('languages.' + language.name) }}</label>
				</div>
			</div>
		</form>
	</div>
</template>